var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.834 8.34988C13.8339 8.52668 13.7637 8.69622 13.6387 8.82121L9.63865 12.8212C9.51292 12.9427 9.34451 13.0098 9.16972 13.0083C8.99492 13.0068 8.82771 12.9367 8.7041 12.8131C8.5805 12.6895 8.51039 12.5223 8.50887 12.3475C8.50735 12.1727 8.57455 12.0043 8.69598 11.8785L11.558 9.01655L3.83398 9.01655C3.65717 9.01655 3.4876 8.94631 3.36258 8.82128C3.23755 8.69626 3.16732 8.52669 3.16732 8.34988C3.16732 8.17307 3.23755 8.0035 3.36258 7.87848C3.4876 7.75345 3.65717 7.68321 3.83398 7.68321L11.558 7.68321L8.69598 4.82121C8.57455 4.69548 8.50735 4.52708 8.50887 4.35228C8.51039 4.17748 8.5805 4.01027 8.70411 3.88667C8.82771 3.76306 8.99492 3.69295 9.16972 3.69143C9.34451 3.68991 9.51292 3.75711 9.63865 3.87855L13.6387 7.87855C13.7637 8.00354 13.8339 8.17308 13.834 8.34988Z",
    fill: "#FD4319"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowSmall);
export default __webpack_public_path__ + "static/media/right-arrow-small.2602613c3f9a36d7f59a1b51052b8efe.svg";
export { ForwardRef as ReactComponent };